import { render, staticRenderFns } from "./cancellationNotice.vue?vue&type=template&id=330ff9a2&scoped=true&"
import script from "./cancellationNotice.vue?vue&type=script&lang=js&"
export * from "./cancellationNotice.vue?vue&type=script&lang=js&"
import style0 from "./cancellationNotice.vue?vue&type=style&index=0&id=330ff9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ff9a2",
  null
  
)

export default component.exports